
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/feedbacks",
      function () {
        return require("private-next-pages/companies/feedbacks/index.tsx");
      }
    ]);
  